import { render, staticRenderFns } from "./VehicleRegistration.vue?vue&type=template&id=23413282&"
import script from "./VehicleRegistration.vue?vue&type=script&lang=ts&"
export * from "./VehicleRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCombobox,VDivider,VIcon})
